import { render, staticRenderFns } from "./EditAttributeMaster.vue?vue&type=template&id=1203ee17&scoped=true"
import script from "./EditAttributeMaster.vue?vue&type=script&lang=js"
export * from "./EditAttributeMaster.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1203ee17",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1203ee17')) {
      api.createRecord('1203ee17', component.options)
    } else {
      api.reload('1203ee17', component.options)
    }
    module.hot.accept("./EditAttributeMaster.vue?vue&type=template&id=1203ee17&scoped=true", function () {
      api.rerender('1203ee17', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/attributes/modules/managment/EditAttributeMaster.vue"
export default component.exports